<template>
  <b-card no-body>
    <b-card-header>
      <h4>{{ $t('bookings.price_offers.your_offer') }}</h4>
    </b-card-header>

    <b-card-body>
      <b-input-group :prepend="currencyLabel">
        <b-form-input v-model="offer.price" readonly />
      </b-input-group>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'PriceOfferForm',
  props: {
    currencyLabel: {
      type: String,
      required: true,
    },
    offer: {
      type: Object,
      required: true,
    },
  },
}
</script>
